<template>
    <Slide :title="title" :subtitle="subtitle">
        <div>
            <div class="cr:grid cr:grid-cols-1 cr:md:grid-cols-2 cr:text-sm">
                <div v-for="type in businessTypes" class="cr:flex cr:items-center cr:gap-2 cr:p-1 cr:my-1">
                    <CustomCheckbox v-model="type.selected" @update:modelValue="handleSelection($event, type)"/>
                    <p>{{ type.name }}</p>
                </div>
            </div>
        </div>
    </Slide>
</template>

<script setup lang="ts">
import Slide from "@/components/slides/Slide.vue";
import CustomCheckbox from "@/components/elements/CustomCheckbox.vue";
import {ref, computed} from "vue";
import {useErrorStore} from "@/stores/error.ts";

const businessTypes = ref([
    {name: 'Independent Agency', selected: false},
    {name: 'Captive Agent', selected: false},
    {name: 'Carrier Insurance Company', selected: false},
    {name: 'MGA/MGU (Managing General Agent/Managing General Underwriter)', selected: false},
]);

const errorStore = useErrorStore();

const props = defineProps({
    title: {
        type: String,
        default: 'Type of Insurance business'
    },
    subtitle: {
        type: String,
        default: ''
    }
});

const handleSelection = (event: any, type: any) => {
    businessTypes.value.forEach(p => p.selected = false);

    if (event) {
        type.selected = true;
    }
}

const slidePayload = computed(() => {
    return {
        type_of_business: businessTypes.value.find(p => p.selected)?.name,
    }
});
const validate = () => {
    if (!businessTypes.value.find(p => p.selected)) {
        errorStore.report('Please select one.')
        return false;
    }

    return true;
}
const canContinue = computed(() => true);

defineExpose({
    canContinue,
    slidePayload,
    validate
});
</script>